import { render, staticRenderFns } from "./WeiboHotTopicsComponent.vue?vue&type=template&id=277dde06&"
import script from "./WeiboHotTopicsComponent.vue?vue&type=script&lang=js&"
export * from "./WeiboHotTopicsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports